<template>
  <div id="app">
    <pageHeader/>
    <pageBody/>
    <a id="Contact"><pageFooter/></a>
    <!--<div class="ads" v-if="ads.length > 0">
      <div>
        <div class="close" v-on:click="closeAd(adIdx)">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
        <a target="_blank" v-bind:href="ads[adIdx].link">
          <img :src="ads[adIdx].imgUrl"/>
        </a>
      </div>
    </div>-->
  </div>
</template>

<script>
import pageHeader from "./components/Header.vue"
import pageBody from "./components/Body"
import pageFooter from "./components/Footer"

export default {
  name: "app",
  components: {
    pageHeader,
    pageBody,
    pageFooter
  },
  /*data:function() {
    return {
      ads: [
        {
          imgUrl: require('./components/assets/adMAFSoccer.png'),
          link: 'https://www.soccershots.org/longislandwest/'
        },
        {
          imgUrl: require('./components/assets/admafgolf.png'),
          link: 'http://mafgolfouting.com/'
        },
        {
          imgUrl: require('./components/assets/adAdventures.png'),
          link: 'https://anchor.fm/megan-carranza'
        },
        {
          imgUrl: require('./components/assets/addMove.png'),
          link: 'https://moveinclusivedance.com/ '
        },
        {
          imgUrl: require('./components/assets/adPBS.png'),
          link: 'http://pbscommunityfoundation.org'
        },
      ],
      adIdx: 0,
    }
  },
  created: function() {
    this.update();
  },
  methods: {
    update () {
      setTimeout(() => {
        this.changeIdx();
        this.update()
      }, 30000);
    },
    changeIdx() {
      if (this.adIdx >= this.ads.length - 1) {
        // at the end
        this.adIdx = 0;
      } else {
        this.adIdx += 1;
      }
    },
    closeAd: function(index) {
      this.changeIdx();
      this.ads.splice(index, 1);
    }
  },*/
}
</script>

<style>
#app{
  margin:-8px !important;
  overflow-x: hidden;
  padding-bottom:0%;
}
body{
  margin-bottom:0 !important;
  font-family: 'futura';
}

.ads {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  right: 0;

  background: rgba(0, 0, 0, 0.6);
  padding: 1rem;
}

.close {
  cursor: pointer;
  position: absolute;
  right: 1.5rem;
  padding-top: .25rem;
}

</style>
